"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        root: function (_a) {
            var lines = _a.lines;
            return ({
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                '-webkit-line-clamp': lines,
                '-webkit-box-orient': 'vertical',
            });
        },
    });
});
